import {config} from 'src/shared/config'

const MOCK_ENVIRONMENTS: ReadonlyArray<string> = ['development', 'unstable', 'testing']

export const MOCK_SCENARIOS = {
  '1': {name: 'delivering', title: 'В пути'},
  '2': {name: 'feedback', title: 'Отзыв'},
  '3': {name: 'postpay', title: 'Постоплата'},
  '4': {name: 'postpayButton', title: 'Оплатить'},
} as const

export type MockScenarioId = keyof typeof MOCK_SCENARIOS
export type MockScenario = (typeof MOCK_SCENARIOS)[MockScenarioId]['name']

export const MOCK_SCENARIO_PARAM = 'debug'
export const MOCK_SHARING_KEY = 'mock'
export const DEV_MOCKS_SHARING_KEY = '00000000-0000-0000-0000-000000000000'

export const isMockEnvironment = (env: string | undefined): boolean =>
  env !== undefined && MOCK_ENVIRONMENTS.includes(env)

const isMockScenarioId = (value: string | null): value is MockScenarioId =>
  value !== null && Object.keys(MOCK_SCENARIOS).includes(value)

export const parseMockScenarioId = (search: string): MockScenarioId | null => {
  const value = new URLSearchParams(search).get(MOCK_SCENARIO_PARAM)
  return isMockScenarioId(value) ? value : null
}

const isMockAllowed = () => typeof window !== 'undefined' && isMockEnvironment(config.env)

export const getMockScenarioId = (): MockScenarioId | null =>
  isMockAllowed() ? parseMockScenarioId(window.location.search) : null

export const getMockScenario = (): MockScenario | null => {
  const id = getMockScenarioId()
  return id ? MOCK_SCENARIOS[id].name : null
}

export const isDevMocksKey = (key: string | undefined): boolean => isMockAllowed() && key === DEV_MOCKS_SHARING_KEY

export const isMockModeActive = (): boolean =>
  isMockAllowed() && (getMockScenarioId() !== null || isDevMocksKey(window.location.hash.substring(1)))

export const ensureMockSharingKey = () => {
  if (getMockScenarioId() === null || window.location.hash) return

  const {pathname, search} = window.location
  window.history.replaceState(window.history.state, '', `${pathname}${search}#${MOCK_SHARING_KEY}`)
}

const MOCK_HASHES: ReadonlyArray<string> = [`#${MOCK_SHARING_KEY}`, `#${DEV_MOCKS_SHARING_KEY}`]

export const toMockScenarioHref = (href: string, id: MockScenarioId | null): string => {
  const url = new URL(href)

  if (id === null) {
    url.searchParams.delete(MOCK_SCENARIO_PARAM)
    if (MOCK_HASHES.includes(url.hash)) url.hash = ''
  } else {
    url.searchParams.set(MOCK_SCENARIO_PARAM, id)
    if (url.hash === `#${DEV_MOCKS_SHARING_KEY}`) url.hash = MOCK_SHARING_KEY
  }

  return url.toString()
}
